module.exports = __webpack_public_path__ + "static/media/19.jpg.aa17ab1a.webp";